import useCareTeamMember from '../../../../../hooks/api/useCareTeamMember';
import { useCollaborators } from '../../../../../hooks/api/useCollaborators';
import { useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { isProvider, isSupport } from '../../../../../utils/careTeamUtils';

export type UseInviteCollaboratorWithDefaultValuesArgs = {
    profileId: string;
    careTeamMemberId: string;
};

export type UseInviteCollaboratorWithDefaultValuesReturnValue = {
    inviteCareTeamCollaborator: () => void;
    isDisabled: boolean;
};

export const useInviteCollaboratorWithDefaultValues = ({
    profileId,
    careTeamMemberId,
}: UseInviteCollaboratorWithDefaultValuesArgs): UseInviteCollaboratorWithDefaultValuesReturnValue => {
    const navigation = useProfilesTabNavigation();
    const { careTeamCollaborators, isLoadingCareTeamCollaborators } = useCollaborators({
        careTeamMemberId,
        medicalProfileId: profileId,
    });
    const { careTeamMember, isLoadingCareTeamMember } = useCareTeamMember({
        careTeamMemberId,
        medicalProfileId: profileId,
    });

    const isDisabled = isLoadingCareTeamCollaborators || isLoadingCareTeamMember;
    const hasExistingCollaborators = careTeamCollaborators?.length > 0;
    if (isDisabled) {
        return {
            inviteCareTeamCollaborator: () => {},
            isDisabled,
        };
    }

    const getFirstName = () => {
        if (careTeamMember && (isProvider(careTeamMember) || isSupport(careTeamMember))) {
            return careTeamMember?.contactDetails?.firstName;
        }
    };

    const getLastName = () => {
        if (careTeamMember && (isProvider(careTeamMember) || isSupport(careTeamMember))) {
            return careTeamMember?.contactDetails?.lastName;
        }
    };

    const inviteCareTeamCollaborator = () => {
        // only default values if no existing collaborator.  We can take a guess that the first collaborator is the care team member themselves
        navigation.navigate('invite-collaborator', {
            profileId: profileId,
            careTeamMemberId: careTeamMemberId,
            // @ts-expect-error TS2322
            defaultFirstName: hasExistingCollaborators ? '' : getFirstName(),
            // @ts-expect-error TS2322
            defaultLastName: hasExistingCollaborators ? '' : getLastName(),
            // @ts-expect-error TS2322
            defaultEmail: hasExistingCollaborators ? '' : careTeamMember?.contactDetails?.email,
        });
    };

    return {
        inviteCareTeamCollaborator,
        isDisabled,
    };
};
